import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import TrustBar from "@/components/home/TrustBar";
import Services from "@/components/home/Services";
import Packages from "@/components/home/Packages";
import Gallery from "@/components/home/Gallery";
import WhyUs from "@/components/home/WhyUs";
import Districts from "@/components/home/Districts";
import Testimonials from "@/components/home/Testimonials";
import Faq from "@/components/home/Faq";
import LeadSection from "@/components/home/LeadSection";
import BlogPreview from "@/components/home/BlogPreview";
import { SITE_ORIGIN } from "@/lib/site";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Ankara Düğün Fotoğrafı",
      url: SITE_ORIGIN,
      inLanguage: "tr-TR",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        { "@type": "Question", name: "Ankara'nın hangi ilçelerinde çekim yapıyorsunuz?", acceptedAnswer: { "@type": "Answer", text: "Ankara'nın 25 ilçesinin tamamında düğün ve gelin damat dış çekimi yapıyoruz." } },
        { "@type": "Question", name: "Fotoğraflar ne zaman teslim ediliyor?", acceptedAnswer: { "@type": "Answer", text: "Düzenlenmiş fotoğraflarınızı çekimden sonra 7 gün içinde dijital olarak teslim ediyoruz." } },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="Ankara Düğün Fotoğrafçısı | Gelin Damat Dış Çekim & Video"
        description="Ankara ve tüm ilçelerinde profesyonel gelin damat dış çekim, düğün fotoğraf ve video hizmeti. Zamansız, şık, sinematik kareler · 7 günde teslim."
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <TrustBar />
      <Services />
      <Packages />
      <Gallery />
      <WhyUs />
      <Districts />
      <Testimonials />
      <Faq />
      <LeadSection />
      <BlogPreview />
    </>
  );
}
